import rootStore from './Stores'

import type { ChatEntityType } from './Contracts/ChatEntityType'

/**
 * Публічний вхід ChatContainer для інших контейнерів: відкрити (створивши
 * за потреби) чат сутності — кнопка «Чат» у картці завдання чи заявки.
 *
 * Фасад свідомо мінімальний: зовнішній контейнер не знає ні про стори
 * чату, ні про його контракти — лише тип сутності та її uuid.
 */
export const openEntityChat = (
    entityType: ChatEntityType,
    entityUuid: string
): Promise<void> => rootStore.chatStore.openEntityChat(entityType, entityUuid)
